import React, { useEffect, useState } from 'react'
import { useFirebaseApp } from 'reactfire'
import RoutePath from '../atoms/RoutePath'
import ProductCard from '../molecules/ProductCard'

const Product=(props)=>{
  const category=props.match.params.category
  const subCategory=props.match.params.subCategory
  const product=props.match.params.product

  const firebase=useFirebaseApp()
  const firestore=firebase.firestore()

  const [state, setstate] = useState({product:[]})
  const [state2, setstate2] = useState({others:[]})

  useEffect(()=>{
    document.documentElement.scrollTop=0
    firestore.collection(`products`).doc(product).get().then(
      doc=>{
        let product
        product=doc.data()
        setstate({
          product
        })
      }
    )

    firestore.collection(`products`).where('category','array-contains',category).limit(3).get().then(
      snap=>{
        let others=[]
        snap.forEach(doc=>{
          if(doc.id !== product){
            others.push({id:doc.id,data:doc.data()})
          }
        })
        
        setstate2({
          others
        })
      }
    )
  },[category,firestore,product])
  const activeImage=(e)=>{
    e.target.classList.toggle('active')
  }

    return (
      <main className="product">
        <RoutePath categoryUrl={category} category={` ${category[0].toUpperCase()+category.slice(1)}`} subCategoryUrl={subCategory} subCategory={`/ ${subCategory[0].toUpperCase()+subCategory.slice(1)}`} product={`/ ${product[0].toUpperCase()+product.slice(1)}`}/>
        <div className='line-cont'>

        <div className="line"></div>
        </div>
        <div className="product-images">
          {
            state.product.images &&
            state.product.images.map(i=>(
              <div key={i} onClick={activeImage} className="modal-image hand">
                <img src={i} alt={state.name}/>
              </div>
            ))
          }
        </div>
        <div className="product-info">
          {
            state.product &&
            (
              <>
              <h1>{state.product.name}</h1>
              <h2>{`S/${state.product.price}.00`}</h2>
              <div className="line"></div>
              <div className="description">
                {
                  state.product.description &&
                  state.product.description.map(d=>(
                    <p key={d}>{d}</p>
                  ))
                }
              </div>
              <div className="line"></div>
              
              <div className="button">
                <a target='_blank' rel='noreferrer' href={`https://api.whatsapp.com/send?phone=51932391656&text=Hola!,%20me%20interesa%20el%20producto%20"${state.product.name}%20".%20Quisiera%20mas%20informacion%20:)`}>Comprar</a>
              </div>
              <p className='contact-url'>*Enlace de contacto con el vendedor</p></>
            )
          }
        </div>
        <div className="others-products">
          <h3>Otros productos</h3>
          <div className="others-products-cards-container">
            {
              state2.others &&
              state2.others.map(o=>(
                <ProductCard key={o.id} product={`${category}/${subCategory}/${o.id}`} name={o.data.name} image={o.data.images[0]} price={o.data.price}/>
              ))
            }
          </div>
        </div>
      </main>
    )
}

export default Product
